import router from './en/router'
import login from './en/login'
import map from './en/map'
import siteOverview from './en/siteOverview'
export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    check: 'Check',
    search: 'Search',
    export: 'Export',
    update: 'Update',
    filter: 'Filter',
    print: 'Print',
    startTime: 'Start time',
    endTime: 'End time',
    noData: 'No data',
    createSuccess: 'Created successfully',
    addSuccess: 'Added successfully',
    editSuccess: 'Modified successfully',
    operateSuccess: 'Operation successful',
    yes: 'Yes',
    no: 'No',
    keywords: 'Keywords',
    phSelect: 'Select',
    phInput: 'Input',
    enterSite: 'Enter site name/site code',
    headTitle: 'Photovoltaic Water Pump System',
    address: 'Address',
    goBack: 'Go Back',
    selectIndicators: 'Select Indicators',
    selectSite: 'Select Site',
    reset: 'Reset',
    searchMetrics: 'Enter keyword search metrics',
    keywordSearch: 'Keyword Search',
  },
  time: {
    second: 'Second',
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    thisWeek: 'This week',
    lastWeek: 'Last Week'
  },
  userSet: {
    userInfor: 'Personal information',
    positionSet: 'Positioning settings',
    safeExit: 'Safe exit'
  },
  controlLog: {
    time: 'Time',
    query: 'Query',
    export: 'Export',
    keyWord: 'Keyword Search',
    number: 'Number',
    pumpHouseName: 'Pump Room Name',
    deviceName: 'Equipment Name',
    deviceId: 'Equipment ID',
    pageMeasurePoint: 'Page Measurement Points',
    controlMeasurePoint: 'Control Measure Point',
    controlValue: 'Lower Control Value',
    excuter: 'Executor',
    controlTime: 'Down control time',
    controlIP: 'Down Control IP',
    controlResult: 'Down Control results',
    startTime: 'Start Time',
    endTime: 'Ending Time',
    lastWeek: 'Recent Week',
    lastMonth: 'Last Month',
    lastQuarter: 'Latest Quarter',
    queryNoData: 'No Data for Query！',
    title: 'Tips',
    tip: 'Export Data or Not?',
    yes: 'Yes',
    no: 'No',
    cancelExport: 'Cancel Export!'
  },
  pumpStatus: {
    all: 'All',
    run: 'Working',
    run1: 'Working',
    offline: 'Offline',
    stop: 'Shutdown',
    fault: 'Failure',
    online: 'On-line',
    startUp: 'Start-up'
  },
  runTime: {
    run: 'Run duration',
    offline: 'Offline duration',
    stop: 'Shutdown duration',
    fault: 'Fault duration'
  },
  energy: {
    kwh: 'Accumulated power generation (Ten Thousand kW ∙ h)',
    kwh1: 'Accumulated power generation',
    kwh2: 'Ten Thousand kW ∙ h',
    coal: 'Standard coal emission reduction (t)',
    so2: 'SO₂ emission reduction (t)',
    co2: 'CO₂ reduction (t)',
    soot: 'Smoke and dust reduction (t)',
    nox: 'NOx emission reduction (t)'
  },
  message: {
    queryNoData: 'No data found in the query!',
    title: 'Tips',
    tip: 'Are you sure to export this data?',
    printTip: 'Are you sure you want to export this data?',
    yes: 'Yes',
    no: 'No',
    cancelExport: 'Cancel Export!',
    successExport: 'Export successful!',
    noDataExport: 'No data export!',
    noSelect: 'No area/measurement point selected!',
    startTime: 'Start time',
    endTime: 'End time',
    minuTip: 'Please select a time of the day!',
    dayTip: 'Please select a time within the current month!',
    shutDownDevice: 'Whether to shut down the machine',
    startUpDevice: 'Start or not',
    // reversalDevice: 'Is it reversed',
    // faultResetDevice: 'Is there a fault reset',
    whetherOrNot: 'Whether or not',
    pumpSite: 'pumping station',
    timeVerification: 'The start time cannot be greater than the end time!',
    exceedDays: 'The query time range must not exceed 7 days!'
  },
  table: {
    time: 'Time',
    user: 'User',
    operate: 'Operate',
    number: 'Index',
    stationName: 'Site name',
    alarmType: 'Alarm type',
    alarmParameters: 'Alarm parameters',
    alarmLevel: 'Alarm level',
    alarmValue: 'Alarm value',
    setValue: 'Set value',
    startTime: 'Start time',
    endTime: 'End time',
    continueTime: 'Duration',
    alarmState: 'Alarm status',
    recentAlarmTime: 'Recent alarm time',
    faultDescription: 'Fault description',
    totalAlarms: 'Accumulated number of alarms',
    all: 'All',
    pointMemo: 'Measurement point name',
    pointValue: 'Numerical value',
    pointUnit: 'Unit',
    timestamp: 'Update time'
  },
  alarm: {
    alarmType: 'Alarm type',
    alarmLevel: 'Alarm level',
    alarmState: 'Alarm status'
  },
  page: {
    total: 'In total',
    items: 'piece of data'
  },
  router,
  login,
  map,
  siteOverview
}
